import DashboardSectionHeading from './DashboardSectionHeading';

export default DashboardSectionHeading;
export * from './DashboardSectionHeading';